import React from 'react';
import MaestroVerifiedBadge from './MaestroVerifiedBadge';
import { isZonePickerSelectable, zonePickerDisabledReason } from '../handlers/rendererZoneMap'; import { isQobuzConnectZone, QOBUZ_CONNECT_LABEL } from '../transport/qobuzConnectRoute';

const GOLD = '#C9A84C';

export function PickerDisabledNetworkRow({ zoneKey, displayName, disabledReason, showVerifiedBadge }) {
  return (
    <div
      key={zoneKey}
      className="text-left px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2 cursor-not-allowed"
      style={{ color: 'var(--text-tertiary)', opacity: 0.55 }}
      title={disabledReason || undefined}
    >
      <span className="flex-shrink-0" style={{ width: 16, height: 16 }} />
      <div className="flex flex-col min-w-0 flex-1">
        <span className="truncate flex items-center gap-1.5 flex-wrap">
          <span className="truncate">{displayName}</span>
          {showVerifiedBadge ? <MaestroVerifiedBadge compact /> : null}
        </span>
        {disabledReason ? (
          <span className="text-[10px] truncate" style={{ color: 'var(--text-tertiary)' }}>{disabledReason}</span>
        ) : null}
      </div>
    </div>
  );
}

export function NetworkZoneMultiRow({ zoneKey, displayName, isChecked, isVerified, onSelect }) {
  return (
    <button
      key={zoneKey}
      onClick={onSelect}
      className="text-left px-3 py-2 rounded-lg text-sm font-medium transition flex items-center gap-3"
      style={{
        background: isChecked ? 'rgba(201, 168, 76, 0.08)' : 'transparent',
        color: isChecked ? GOLD : 'var(--text-primary)',
      }}
    >
      <span
        className="flex-shrink-0 flex items-center justify-center rounded"
        style={{
          width: 18, height: 18,
          border: isChecked ? `2px solid ${GOLD}` : '2px solid var(--border)',
          background: isChecked ? GOLD : 'transparent',
        }}
      >
        {isChecked && (
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#1a1a2e" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </span>
      <span className="truncate flex items-center gap-1.5">
        <span className="truncate">{displayName}</span>
        {isVerified ? <MaestroVerifiedBadge compact /> : null}
      </span>
    </button>
  );
}

export function buildNetworkZonePickerRow({
  zone, displayName, isActive, mode, isChecked, isVerified, onSelect, renderDeviceRow, handleSelectRenderer,
}) {
  if (!isZonePickerSelectable(zone)) {
    return (
      <PickerDisabledNetworkRow
        zoneKey={zone.id || zone.name}
        displayName={displayName}
        disabledReason={zonePickerDisabledReason(zone)}
        showVerifiedBadge={isVerified}
      />
    );
  }
  if (mode === 'single') {
    return renderDeviceRow(zone.id || zone.name, displayName, isActive, () => handleSelectRenderer(zone), null, {
      showVerifiedBadge: isVerified, subtitle: isQobuzConnectZone(zone) ? QOBUZ_CONNECT_LABEL : undefined,
    });
  }
  return (
    <NetworkZoneMultiRow
      zoneKey={zone.id || zone.name}
      displayName={displayName}
      isChecked={isChecked}
      isVerified={isVerified}
      onSelect={() => handleSelectRenderer(zone)}
    />
  );
}
